<template>
  <v-sheet class="px-3">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>

    <v-row class="header-sticky">
      <v-card :color="$vuetify.theme.dark ? '#2E2E2E' : 'grey lighten-3'" min-width="640" class="w-100" :width="'100%'" elevation="0">
        <v-card-title>
          <v-row justify="start" no-gutters>
            <v-icon large class="pr-2">mdi-account-box-multiple-outline</v-icon>
            <h3>{{ $t("presencelist") }}</h3>
          </v-row>
        </v-card-title>
        <v-card-text class="px-8">
          <v-row>
            <v-col cols="12">
              <v-row justfiy="space-around">
                <v-col cols="4">
                  <v-row justify="center">
                    <v-text-field
                      v-model="anwesenheitsListsearch"
                      :label="$t('search')"
                      :placeholder="$t('searchHere') + '...'"
                      color="primary"
                      class="mx-2"
                      hide-details
                      clearable
                    >
                      <template slot="append">
                        <v-icon v-if="anwesenheitsListsearch == ''">mdi-magnify</v-icon>
                      </template>
                    </v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <v-row justify="center">
                    <v-select
                      v-model="groupSearchSelect"
                      :items="teamList"
                      color="primary"
                      :value="$t('all')"
                      class="mx-2"
                      :disabled="formShow.includes('dataTable') != true"
                      @change="filterAnwesenheitslist()"
                      required
                    ></v-select>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row justify="center">
                    <v-checkbox
                      v-model="showOnlyPresentMembers"
                      :label="$t('showOnlyPresentEmployee')"
                      color="primary"
                      class="mx-1"
                      @change="filterAnwesenheitslist()"
                    ></v-checkbox>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <v-row justify="center" class="pt-3" no-gutters>
                    <h3 class="d-flex justify-center">{{ $t("employees") }}</h3>
                    <v-tooltip top class="mx-2 mt-1" color="green">
                      <template slot="activator" slot-scope="{ on, attrs }">
                        <div v-on="on" v-bind="attrs"><v-avatar color="green" class="mx-2" size="12"></v-avatar>{{ presentEmployeeCounter }}</div>
                      </template>
                      <span
                        :class="this.$vuetify.theme.dark ? '' : 'textColor--text'"
                        v-html="$t('presentEmployeesTooltip').format(usersInHouse, usersInHomeOffice, usersOut)"
                      ></span>
                    </v-tooltip>
                    <v-tooltip top class="mx-2 mt-1" color="primary">
                      <template slot="activator" slot-scope="{ on, attrs }">
                        <div v-on="on" v-bind="attrs"><v-avatar color="red" class="mx-2" size="12"></v-avatar>{{ absenceEmployeeCounter }}</div>
                      </template>
                      <span :class="this.$vuetify.theme.dark ? '' : 'textColor--text'" v-html="setAbsentHint()"></span>
                    </v-tooltip>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row class="presence-list-scroll" tile>
      <v-card :color="$vuetify.theme.dark ? '#2E2E2E' : 'grey lighten-3'" min-width="640" class="w-100" :width="'100%'">
        <v-card-text class="px-8">
          <v-row justify="end">
            <v-row style="height: 30px" justify="end">
              <v-progress-circular v-show="progressCircular" color="primary" indeterminate size="24"></v-progress-circular>
            </v-row>
          </v-row>
          <Cards v-if="formShow.includes('dataTable') == true" :Employees="employees" :SearchVal="anwesenheitsListsearch" @click="openEmployeeInfo" />
        </v-card-text>
      </v-card>
    </v-row>

    <Legend v-if="dialogLegende" @close="dialogLegende = false" />
    <div v-if="!dialogLegende" id="overflowButtons">
      <v-tooltip bottom color="primary">
        <template slot="activator" slot-scope="{ on }">
          <v-btn id="legendButton" v-on="on" color="primary" fab fixed top right @click="dialogLegende = true">
            <v-icon style="height: unset">mdi-table-of-contents</v-icon>
          </v-btn>
        </template>
        <span class style="align-items: end">{{ $t("showLegend") }}</span>
      </v-tooltip>
    </div>
    <HistoryMonthDialog v-if="ShowHistoryMonthDialog" @close="ShowHistoryMonthDialog = false" @OpenDailyHistory="OpenDailyHistory" :User="selectedUser" />
    <DailyHistoryDialog v-if="ShowDailyHistoryDialog" @close="dailyHistoryDialogClose" :User="selectedUser" :date="DailyHistoryDate" />
    <EmployeeInformation
      v-if="showEmployeeInformationDialog"
      :user="selectedUser"
      :profilePicture="profilePicture"
      :status="status"
      :workedHours="workedHours"
      :pauseHours="pauseHours"
      :balance="balance"
      :pauseDebit="pauseDebit"
      :holidayInfo="holidayInfo"
      :showNotification="false"
      :ownInfo="$store.getters['user/user'].SAPEmpId === selectedUser.SAPEmpId"
      :showHolidaysButton="false"
      @closed="showEmployeeInformationDialog = false"
      @showMonthlyHistoryClicked="HistoryMonthDialogOpen"
      @showHistoryClicked="OpenDailyHistory(new Date().toISOString().substr(0, 10))"
      @addVacationClicked="ShowAbsenceDialog = true"
    />
    <AbsenceDialog v-if="ShowAbsenceDialog" @close="ShowAbsenceDialog = false" :CanSendAbsence="false" :User="$store.getters['user/user']" :IsVacation="true" />
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PresenceList",
  route: "PresenceList",
  components: {
    Cards: () => import("../components/PresenceList/Cards"),
    Legend: () => import("../components/PresenceList/Legend"),
    HistoryMonthDialog: () => import("../components/HistoryMonthDialog"),
    DailyHistoryDialog: () => import("../components/dailyHistoryDialog"),
    EmployeeInformation: () => import("../components/EmployeeInformation"),
    AbsenceDialog: () => import("../components/absenceDialog")
  },
  data: (vm) => ({
    formShow: ["dataTable"],
    groupSearch: [vm.$t("all")],
    groupSearchSelect: null,
    showOnlyPresentMembers: false,
    anwesenheitsListsearch: "",
    presentEmployeeCounter: 0,
    absenceEmployeeCounter: 0,
    usersInHouse: 0,
    usersInHomeOffice: 0,
    usersOut: 0,
    refreshInterval: "",
    refreshTimerInMS: 60000,
    dialogLegende: false,
    ShowHistoryMonthDialog: false,
    selectedUser: "",
    ShowDailyHistoryDialog: false,
    DailyHistoryDate: "",
    loaderOverlay: false,
    progressCircular: false,
    showEmployeeInformationDialog: false,
    workedHours: "00:00",
    pauseHours: "00:00",
    balance: "",
    pauseDebit: "00:00",
    holidayInfo: null,
    profilePicture: null,
    status: null,
    ShowAbsenceDialog: false,
    absences: {}
  }),
  computed: {
    employees: function () {
      return this.presenceList.filter((employee) => {
        return employee.show;
      });
    },
    ...mapGetters({
      teams: "users/teams",
      cobiUser: "user/user",
      presenceList: "users/presenceList"
    }),
    teamList() {
      let list = [];
      list.push(this.$t("all"));
      if (this.cobiUser.userGroupRights.canAccessAdminPresenceList || this.cobiUser.userGroupRights.canManipulateBookingLines) {
        list = this.teams;
      } else {
        this.cobiUser.Teams.forEach((team) => {
          list.push(team.Team);
        });
      }
      return list;
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  async created() {
    this.loaderOverlay = true;
    await this.initialize();
    this.refresh();
    this.refreshInterval = window.setInterval(this.refresh, this.refreshTimerInMS);
    this.loaderOverlay = false;
  },
  beforeDestroy: function () {
    window.clearInterval(this.refreshInterval);
  },
  methods: {
    async initialize() {
      await this.getStatus();
      await this.getSettings();
      await this.getTeams();
      await this.getAbsences();
      if (this.$store.getters["settings/lastStatusPresenceList"] != "") {
        if (this.groupSearch.includes(this.$store.getters["settings/lastStatusPresenceList"]))
          this.groupSearchSelect = this.$store.getters["settings/lastStatusPresenceList"];
        else this.groupSearchSelect = this.$t("all");
      } else this.groupSearchSelect = this.$t("all");
    },
    async getStatus() {
      await this.$store
        .dispatch("user/getStatus", {
          timeStamp: this.$moment(),
          executeImmediately: false
        })
        .then(() => {
          if (
            !this.$store.getters["user/user"].userGroupRights.canAccessPresenceList &&
            !this.$store.getters["user/user"].userGroupRights.canAccessAdminPresenceList &&
            !this.$store.getters["user/user"].userGroupRights.canManipulateBookingLines
          )
            this.$router.push("MainMenu");
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.showMessage(err.response.data);
          }
        });
    },
    async getTeams() {
      await this.$store
        .dispatch("users/getTeams")
        .then(() => {
          this.groupSearch = this.teams;
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data, "bottom", "right");
          }
        });
    },
    async refresh() {
      this.progressCircular = true;
      await this.getAnwesenheitsliste();
      this.filterAnwesenheitslist();
      this.progressCircular = false;
    },
    clearFilter() {
      this.anwesenheitsListsearch = "";
      this.showOnlyPresentMembers = false;
      this.groupSearchSelect = this.$t("all");
      this.filterAnwesenheitslist();
    },
    HistoryMonthDialogOpen(SAPEmpId) {
      if (this.cobiUser.userGroupRights.canAccessWorkTime || this.cobiUser.userGroupRights.canManipulateBookingLines) {
        this.ShowHistoryMonthDialog = true;
      } else if (SAPEmpId == this.cobiUser.SAPEmpId) {
        this.ShowHistoryMonthDialog = true;
      }
    },
    async dailyHistoryDialogClose(timeWasChanged) {
      this.ShowDailyHistoryDialog = false;
    },
    async filterAnwesenheitslist() {
      if (this.groupSearchSelect != this.$store.getters["settings/lastStatusPresenceList"])
        await this.$store.dispatch("settings/setLastStatusPresencelist", this.groupSearchSelect).then((resp) => {});
      if (this.formShow.includes("dataTable") && this.groupSearchSelect != this.$t("all")) {
        let vm = this;
        let selectedTeam = this.groupSearchSelect;
        this.presenceList.map(function (employee) {
          let empStatus = vm.arbeitszustand(employee.status);
          let teamFound = employee.teams.find((team) => team.Team == selectedTeam);
          if ((teamFound && vm.showOnlyPresentMembers && empStatus == "Anwesend") || (teamFound && vm.showOnlyPresentMembers && empStatus == "Im Projekt"))
            employee.show = true;
          else if (teamFound && !vm.showOnlyPresentMembers) employee.show = true;
          else employee.show = false;
        });
      } else {
        let vm = this;
        this.presenceList.map(function (employee) {
          let empStatus = vm.arbeitszustand(employee.status);
          if ((vm.showOnlyPresentMembers && empStatus == "Anwesend") || (vm.showOnlyPresentMembers && empStatus == "Im Projekt")) employee.show = true;
          else if (!vm.showOnlyPresentMembers) employee.show = true;
          else employee.show = false;
        });
      }
    },
    async getAnwesenheitsliste() {
      await this.$store
        .dispatch("users/getPresenceList")
        .then(() => {
          this.presentEmployeeCounter = 0;
          this.absenceEmployeeCounter = 0;
          this.presenceList.map((item) => {
            switch (item.status) {
              case "Present":
              case "Break":
              case "inproject":
                this.presentEmployeeCounter++;
                return;
              default:
                this.absenceEmployeeCounter++;
                return;
            }
          });
          this.usersInHouse = 0;
          this.usersInHomeOffice = 0;
          this.usersOut = 0;
          this.presenceList
            .filter((user) => user.status === "Present" || user.status === "inproject" || user.status === "Break")
            .map((item) => {
              switch (item.userLocation) {
                case "statusInHouse":
                  this.usersInHouse++;
                  return;
                case "statusOut":
                  this.usersOut++;
                  return;
                case "statusHomeOffice":
                  this.usersInHomeOffice++;
                  return;
                default:
                  return;
              }
            });
          this.absences = {};
          this.presenceList
            .filter(
              (user) =>
                user.userLocation !== "statusHomeOffice" &&
                user.userLocation !== "statusInHouse" &&
                user.userLocation !== "statusOut" &&
                user.userLocation !== null &&
                user.userLocation !== undefined &&
                user.userLocation !== "" &&
                user.userLocation !== "null"
            )
            .map((item) => {
              if (item.userLocation !== null && !Object.hasOwn(this.absences, item.userLocation)) {
                this.absences[item.userLocation] = 1;
              } else if (item.userLocation !== null) {
                this.absences[item.userLocation]++;
              }
            });
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },
    arbeitszustand(status) {
      let resultStatus = "";
      switch (status) {
        case "WorkStart":
        case "PauseEnd":
        case "Present":
        case "ProjectEnd":
          resultStatus = "Anwesend";
          break;
        case "ProjectStart":
        case "ProjectPauseEnd":
        case "In Project":
          resultStatus = "Im Projekt";
          break;
        case "ProjectPauseStart":
        case "PauseStart":
          resultStatus = "In der Pause";
          break;
        default:
          resultStatus = "Abwesend";
      }
      return resultStatus;
    },
    OpenDailyHistory(dateTime) {
      this.DailyHistoryDate = dateTime;
      this.ShowDailyHistoryDialog = true;
    },
    async openEmployeeInfo(user) {
      let userGroup = this.$store.getters["user/user"].userGroupRights;

      if (
        userGroup.canAccessWorkTime ||
        this.$store.getters["user/user"].SAPEmpId === user.SAPEmpId ||
        (userGroup.canAccessWorkTimeTeam && this.hasMatchingTeams(user))
      ) {
        this.selectedUser = user;
        this.showEmployeeInformationDialog = true;
      }
    },
    hasMatchingTeams(user) {
      let currentUser = this.employees.find((u) => u.SAPEmpId === this.$store.getters["user/user"].SAPEmpId);
      return user.teams.some((userTeam) => currentUser.teams.some((currentUserTeam) => currentUserTeam.Team === userTeam.Team));
    },
    async getSettings() {
      await this.$store
        .dispatch("server/getSettings", this.$moment())
        .then(() => {})
        .catch((err) => {
          if (err.response.status != 200) {
            this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
          }
        });
    },
    async getAbsences() {
      return this.$store.dispatch("server/getAbsenceReasons").catch((err) => {
        if (err.response.status != 200) {
          this.$eventHub.$emit("showError", err.response.data);
        }
      });
    },
    setAbsentHint() {
      return (
        this.$t("absenceEmployeesTooltip") +
        "<br>" +
        Object.entries(this.absences)
          .map(([key, value]) => `${key}: ${value}`)
          .join("<br>")
      );
    }
  }
};
</script>

<style scoped>
button#legendButton {
  top: 60px;
}
.header-sticky {
  position: sticky;
  top: 0;
  z-index: 3;
  background: inherit;
}
.header-sticky .v-card__text {
  padding-bottom: 0px;
}
.presence-list-scroll {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}
.presence-list-scroll {
  min-height: calc(100vh - 220px);
  overflow-y: auto;
}
.presence-list-scroll {
  display: flex;
}
.presence-list-scroll > .v-card {
  flex: 1;
}
</style>
